import { Alert, Button, Card, Space, Typography } from 'antd'

import { loginStyles } from './loginStyles'
import { useLoginPage } from './useLoginPage'

const { Title, Text } = Typography

export function Login() {
  const {
    t,
    error,
    sessionExpired,
    isPending,
    loadingProvider,
    googleButtonRef,
    handleKakaoLogin,
    handleNaverLogin,
    handleAppleLogin,
  } = useLoginPage()

  return (
    <div style={loginStyles.container}>
      <Card style={loginStyles.card}>
        <div style={loginStyles.header}>
          <img src="/boltb-logo.png" alt="BoltB" style={loginStyles.logo} />
          <Title level={2} style={loginStyles.title}>
            {t('pages.login.title')}
          </Title>
          <Text type="secondary">{t('pages.login.subtitle')}</Text>
        </div>

        {sessionExpired && (
          <Alert
            data-testid="login-session-expired-alert"
            message={t('pages.login.sessionExpired')}
            description={t('pages.login.sessionExpiredDescription')}
            type="warning"
            showIcon
            closable
            style={{ marginBottom: 16 }}
          />
        )}

        {error && (
          <Alert
            data-testid="login-error-alert"
            message={t('common.errors.loginFailed')}
            description={error}
            type="error"
            showIcon
            closable
            onClose={() => {}}
            style={{ marginBottom: 16 }}
          />
        )}

        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Button
            data-testid="login-kakao-btn"
            block
            size="large"
            style={loginStyles.kakaoButton}
            onClick={handleKakaoLogin}
            loading={loadingProvider === 'KAKAO'}
            disabled={isPending}
          >
            {t('pages.login.kakaoLogin')}
          </Button>
          <Button
            data-testid="login-naver-btn"
            block
            size="large"
            style={loginStyles.naverButton}
            onClick={handleNaverLogin}
            loading={loadingProvider === 'NAVER'}
            disabled={isPending}
          >
            {t('pages.login.naverLogin')}
          </Button>
          <div
            ref={googleButtonRef}
            data-testid="login-google-btn"
            style={{ display: 'flex', justifyContent: 'center' }}
          />
          <Button
            data-testid="login-apple-btn"
            block
            size="large"
            style={loginStyles.appleButton}
            onClick={handleAppleLogin}
            loading={loadingProvider === 'APPLE'}
            disabled={isPending}
          >
            {t('pages.login.appleLogin')}
          </Button>
        </Space>
      </Card>
    </div>
  )
}
